import {
  maxLength,
  required,
  minLength,
  email,
  helpers,
} from 'vuelidate/lib/validators'

export {
  maxLength,
  required,
  minLength,
  email,
  helpers,
  url,
  requiredIf,
} from 'vuelidate/lib/validators'

export const MAX_WORDMARK_CHARS = 35
export const MIN_WORDMARK_CHARS = 1
export const MAX_SLOGAN_CHARS = 44
export const MIN_SLOGAN_CHARS = 0

export const MAX_INDUSTRY_CHARS = 100
export const MIN_INDUSTRY_CHARS = 0

export const GENERIC_MAX_STRING_LENGTH = 128

export const MAX_KEYWORD_CHARS = 50

export const ACCEPTED_LOGO_CHARS_PATTERN = /^$|^[a-zA-Z0-9_ -=.!?“’@]+$/

export const ACCEPTED_PHONE_PATTERN = /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{0,8}$/

export const ACCEPTED_NAME_CHARS_PATTERN = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/

export const MAX_SCRIPT_CHARS = 3

export const MAX_MONOGRAM_CHARS = 1

const accepted_pattern = helpers.regex(
  'accepted_pattern',
  ACCEPTED_LOGO_CHARS_PATTERN
)

const accepted_names_pattern = helpers.regex(
  'accepted_names_pattern',
  ACCEPTED_NAME_CHARS_PATTERN
)

const accepted_phone_pattern = helpers.regex(
  'accepted_phone_pattern',
  ACCEPTED_PHONE_PATTERN
)

const maxWords = max =>
  helpers.withParams(
    { type: 'maxWords', max },
    keywords => keywords.trim().split(' ').length <= max
  )

export const wordmark_validator = {
  required,
  accepted_pattern,
  maxLength: maxLength(MAX_WORDMARK_CHARS),
  minLength: minLength(MIN_WORDMARK_CHARS),
}

export const slogan_validator = {
  accepted_pattern,
  maxLength: maxLength(MAX_SLOGAN_CHARS),
}

export const keyword_validator = {
  maxLength: maxLength(MAX_KEYWORD_CHARS),
  maxWords: maxWords(10),
}

export const name_validator = {
  required,
  accepted_names_pattern,
  maxLength: maxLength(50),
}

export const email_validator = {
  required,
  email,
  maxLength: maxLength(50),
}

export const phone_validator = {
  required,
  accepted_phone_pattern,
}

export const password_validator = {
  required,
  minLength: minLength(8),
  maxLength: maxLength(128),
}

export const industry_query_validator = {
  maxLength: maxLength(MAX_INDUSTRY_CHARS),
  accepted_pattern,
  required,
}

export const script_validator = {
  maxLength: maxLength(MAX_SCRIPT_CHARS),
  accepted_pattern,
}

export const monogram_validator = {
  maxLength: maxLength(MAX_MONOGRAM_CHARS),
  minLength: maxLength(MAX_MONOGRAM_CHARS),
}
